import { render, staticRenderFns } from "./CourseDuration.vue?vue&type=template&id=855818da&scoped=true&"
import script from "./CourseDuration.vue?vue&type=script&lang=js&"
export * from "./CourseDuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "855818da",
  null
  
)

export default component.exports